import "@arco-design/web-react/es/Image/style";
import _Image from "@arco-design/web-react/es/Image";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import React from 'react';
import { useCaptcha } from './api';
export function Captcha({
  onChange
}) {
  const {
    data,
    refetch,
    isFetching,
    isLoading,
    isError
  } = useCaptcha({
    config: {
      onSuccess: res => {
        if (onChange) {
          onChange(res.data.key, null);
        }
      },
      refetchOnWindowFocus: false,
      onError: () => {// Message.error(err.message);
      }
    }
  });

  if (isLoading || isFetching) {
    return /*#__PURE__*/React.createElement(_Spin, {
      loading: true,
      delay: 300,
      style: {
        width: '100%',
        textAlign: 'center'
      }
    });
  }

  if (isError) {
    return null;
  }

  return /*#__PURE__*/React.createElement(_Image, {
    onClick: () => refetch(),
    width: 96,
    preview: false,
    height: 32,
    src: data.data.captcha,
    alt: "capture",
    style: {
      cursor: 'pointer'
    }
  });
}